const AdobeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 234">
    <path
      d="M42.5 0h155C221 0 240 19 240 42.5v149c0 23.5-19 42.5-42.5 42.5h-155C19 234 0 215 0 191.5v-149C0 19 19 0 42.5 0z"
      fill="#fa0f00"
    />
    <path
      d="M193 135.5c-11.1-11.8-41.8-7-49-5.8-10.6-10.3-18-22.5-20.5-27 4-11.4 6.6-23.5 7-35.4 0-10.8-4.3-22.4-16.3-22.4-4.2.1-8 2.4-10.1 5.9-5.1 8.8-3.1 27 5.1 45.4-4.8 13.5-11.7 33-20.8 48.8-12.3 4.9-38.4 16.9-40.9 30.2-.8 3.9.6 7.9 3.6 10.6 2.9 2.6 6.7 3.9 10.6 3.8 15.7 0 31.4-21.8 42-40.5 8.9-3.1 23.1-7.2 37.4-9.8 16.6 14.5 31.4 16.7 38.9 16.7 10.2 0 14-4.4 15.4-8.1 1.5-4.2.6-9-2.4-12.4zm-10.8 7.6c-.5 2.9-4.2 5.8-11.1 4.3-8-2-15.5-5.8-21.8-11 5.4-.9 18-2.1 26.9-.4 3.2.6 6.9 2.4 6 7.1zm-71.6-88.5c.7-1.3 2-2.2 3.5-2.2 3.8 0 4.6 4.6 4.6 8.4-.5 9.1-2.5 18.4-5 26.7-6.4-17-5.5-28.8-3.1-32.9zm-.9 83.1c3.4-6.7 8.2-18.9 9.9-23.8 3.8 6.3 10.2 14.2 13.6 17.8.1-.1-13 2.6-23.5 6zm-25.1 17.2c-10.1 16.2-20 26.4-25.8 26.4-.9 0-1.9-.3-2.6-.9-1.1-.9-1.6-2.3-1.3-3.7 1.1-5.8 12.6-14.2 29.7-21.8z"
      fill="#fff"
    />
  </svg>
);

export default AdobeIcon;